import { useEffect, useState } from 'react'

import { useTagContext } from '../../../contexts/tagContext'
import { usePannellumViewer } from '../../../hooks/usePannellum'
import { useImageViewerContext } from '../../views/image_viewer/imageViewerContext'
import { ViewerPosition } from '../../views/image_viewer/types'

import { SafetyTag } from './SafetyTag/SafetyTag'

interface SafetyTagManagerProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper tag type
  tag: any
  viewerId: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper hydrate type
  hydrate: any
  viewerPosition: ViewerPosition
}

export const SafetyTagManager = ({
  tag: _tag,
  viewerId,
  hydrate,
  viewerPosition,
}: SafetyTagManagerProps) => {
  const { state: ImageViewerState } = useImageViewerContext()
  const [transform, setTransform] = useState<string>('')
  const { state: tagState } = useTagContext()
  const { viewer } = usePannellumViewer(viewerId)
  const currentTag = useTagContext().state.tags.current

  const renderDialogue = () => {
    const dom = document.getElementById('tag-container')
    if (dom && viewer) {
      const ctya = currentTag.yaw,
        canvasPitch = viewerPosition.pitch,
        canvasYaw = viewerPosition.yaw - ImageViewerState.master.data.angle,
        canvasHfov = viewerPosition.hfov,
        hsPitchSin = Math.sin((currentTag.pitch * Math.PI) / 180),
        hsPitchCos = Math.cos((currentTag.pitch * Math.PI) / 180),
        configPitchSin = Math.sin((canvasPitch * Math.PI) / 180),
        configPitchCos = Math.cos((canvasPitch * Math.PI) / 180),
        yawCos = Math.cos(((-ctya + canvasYaw) * Math.PI) / 180)
      const z =
        hsPitchSin * configPitchSin + hsPitchCos * yawCos * configPitchCos
      const yawSin = Math.sin(((-ctya + canvasYaw) * Math.PI) / 180)
      const hfovTan = Math.tan((canvasHfov * Math.PI) / 360)
      const canvas = viewer.getRenderer().getCanvas()
      const canvasWidth = canvas.clientWidth
      const canvasHeight = canvas.clientHeight
      const coord = [
        ((-canvasWidth / hfovTan) * yawSin * hsPitchCos) / z / 2,
        ((-canvasWidth / hfovTan) *
          (hsPitchSin * configPitchCos -
            hsPitchCos * yawCos * configPitchSin)) /
          z /
          2,
      ]
      coord[0] += (canvasWidth - dom.offsetWidth + 300) / 2
      coord[1] += (canvasHeight - dom.offsetHeight - 560) / 2
      const t =
        'translate(' + coord[0] + 'px, ' + coord[1] + 'px) translateZ(9999px)'
      setTransform(t)
    }
  }

  useEffect(() => {
    if (tagState.displayDialogue) {
      renderDialogue()
    }
  })

  return (
    <>
      {tagState.displayDialogue && currentTag.type === 'SAFETY' && (
        <SafetyTag
          safetyTag={currentTag}
          transform={transform}
          hydrate={hydrate}
        />
      )}
    </>
  )
}
